import { render, staticRenderFns } from "./EnvelopeList.vue?vue&type=template&id=d84318e6"
import script from "./EnvelopeList.vue?vue&type=script&lang=js"
export * from "./EnvelopeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports